// extracted by mini-css-extract-plugin
export default {"root":"newSidebar_root__G+Z8m","panel":"newSidebar_panel__ig02+"};